<script setup>

import { computed, onMounted, ref } from 'vue';
import * as Y from 'yjs';
import DiffViewer from '../../diff/DiffViewer.vue';

import { DOMSerializer } from 'prosemirror-model';
import { schema as defaultSchema } from 'prosemirror-schema-basic';
import { yDocToProsemirrorJSON } from 'y-prosemirror'; // helper abstraction

const {history} = defineProps(['history'])

const schema = window.__EDITOR.schema || defaultSchema;

let lastVisible = null;

const selection = ref(0);
const diffTuple = computed(() => getDiff(selection.value))

function getDiff(N) {

  function base64ToArrayBuffer(base64) {
    let binaryString = atob(base64);
    let bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  let A, B;

  const ydoc = new Y.Doc()
  
  function html() {

    function cleanProsemirrorJSON(json, schema) {

      const cleanMarks = (marks) => {
        return (marks || []).filter(mark => {
          const isKnown = schema.marks[mark.type];
          if (!isKnown) {
            console.warn(`⚠️ Unknown mark type ignored: ${mark.type}`);
          }
          return isKnown;
        });
      };

      const cleanNode = (node) => {
        // Skip unknown node types entirely
        if (!schema.nodes[node.type]) {
          console.warn(`Skipping unknown node type: ${node.type}`);
          return null;
        }

        const cleaned = {
          ...node,
          content: node.content
            ?.map(cleanNode)
            .filter(Boolean),
          marks: cleanMarks(node.marks),
        };

        return cleaned;
      };

      return cleanNode(json);
    }


    const pmJson = yDocToProsemirrorJSON(ydoc, 'default');
    const safeJson = cleanProsemirrorJSON(pmJson, schema);

    const pmNode = schema.nodeFromJSON(safeJson);
    const serializer = DOMSerializer.fromSchema(schema);
    const fragment = serializer.serializeFragment(pmNode.content);
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(fragment);
    const html = tempDiv.innerHTML;
    return html
  }

  for (let i = history.length - 1; i >= N; i --) {
    const {c: change} = history[i]
    const binary = base64ToArrayBuffer(change)
    Y.applyUpdate(ydoc, binary)
    if (i === N) {
      A = html()
    } else if (i === N + 1) {
      B = html()
    }
  }  
  return [A, B];
} 

onMounted(async () => {
})

function renderTime(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

</script>

<template>
  <div class="master-detail ">
    
      <ul class="text-sm pr-3 master-view">
        <li v-for="(update, i) in history" 
          @click="selection = i"
          :class="['selectable item', i === selection && 'selected']">
          <div>{{renderTime(update.t)}}</div>        
        </li>        
      </ul>
    
    
    <div data-theme="light" class="flex-1 diff-content a-scrollable">
      <DiffViewer 
        v-if="diffTuple[0] && diffTuple[1]"
        :oldHtml="diffTuple[1]" :newHtml="diffTuple[0]" class="prose prose-sm"></DiffViewer>

      <div
        v-else-if="diffTuple[0]"
        v-html="diffTuple[0]"
        class="prose prose-sm"></div>

    </div>
  </div>
    
</template>

<style scoped lang="less">
  .diff-content {
    padding: 10px 15px;  
    border-radius: 10px;
  }
  .master-detail {
    overflow: auto;
    display: flex;
    flex-shrink: 0;
    flex: 1;
    flex-direction: column;
    align-items: stretch;
    @media (min-width: @screen-md) {
      & {
        flex-direction: row;
        align-items: unset;
      }
    }
  }
  .master-view {
    display: flex;
    flex-direction: row;
    gap: 5px;
    overflow: auto;
    padding-bottom: 10px;    
    @media (min-width: @screen-md) {
      & {
        flex-direction: column;
        padding-bottom: 0;
        padding-right: 10px;
        // display: block;
              
      }
    }
  }
</style>